import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header align-items-center" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table table-bordered table-sm" }
const _hoisted_6 = { class: "fw-bold text-primary border-bottom-2 border-primary" }
const _hoisted_7 = { class: "border" }
const _hoisted_8 = { class: "pt-5 ps-5" }

import { reactive, toRefs, computed } from "vue";
import CommonProps from "./Props/CommonProps";
import { turnoList } from "@/core/listas/turnoList";


export default /*@__PURE__*/_defineComponent({
  __name: 'TabelaInput',
  props: CommonProps,
  emits: ["dadosTabela"],
  setup(__props, { emit: __emit }) {

const props = __props;
const { dataListTable, customProps, nomeEnsino } = toRefs(props);

const emit = __emit;

const body = computed(() => {
  const bodyTable = setBodyTable(dataListTable.value);
  return bodyTable;
});

const header = computed(() => {
  const headerTable = setHeaderTable(dataListTable.value);
  const filteredArray: any = multiDimensionalUnique(headerTable);
  return filteredArray.sort((a, b) => {
    return ("" + a.turno).localeCompare(b.turno);
  });
});

function multiDimensionalUnique(headerTable: any) {
  var arrayDeValoresUnicos = [] as any;
  var itemAchado = {};
  for (var i = 0, l = headerTable.length; i < l; i++) {
    var stringified = JSON.stringify(headerTable[i].turno);
    if (itemAchado[stringified]) {
      continue;
    }
    arrayDeValoresUnicos.push(headerTable[i]);
    itemAchado[stringified] = true;
  }
  return arrayDeValoresUnicos;
}

const data = reactive({
  form: {
    input: [] as any,
  },
});

function setDadosTabela(event) {
  const convertedData = converterDadosParaEnviar(data.form);
  emit("dadosTabela", convertedData, event.target);
}

function converterDadosParaEnviar(dados) {
  const dataToSendToBack = [] as any[];
  for (const key in dados.input) {
    const dadosConvertidos = key.split("_");
    dataToSendToBack.push({
      id: dadosConvertidos[1],
      value: dados.input[key],
    });
  }
  return dataToSendToBack;
}

function setHeaderTable(dadosDoBanco) {
  return dadosDoBanco.map((e) => {
    return {
      turno: e.fase,
    };
  });
}

function setBodyTable(dadosDoBanco) {
  const dadosDoBancoMapeados = dadosDoBanco.map((e) => {
    return e.turno;
  });
  const dadosProntosParaOComponent = mapearInputsDaTabela(
    dadosDoBancoMapeados,
    dadosDoBanco
  );
  gerarDataReativaDinamica(dadosProntosParaOComponent);
  return dadosProntosParaOComponent;
}

function gerarDataReativaDinamica(dadosDoBancoMapeados) {
  for (const dados of dadosDoBancoMapeados) {
    for (const valor of dados.values) {
      data.form.input[`id_${valor.id}`] = valor[customProps.value];
    }
  }
}

function mapearInputsDaTabela(dadosDoBancoMapeados, dadosDoBanco) {
  const filteredArray = dadosDoBancoMapeados.filter(
    (data, index) => dadosDoBancoMapeados.indexOf(data) === index
  );
  return filteredArray.map((turnoFiltered) => {
    let filteredData = dadosDoBanco.filter((bodyTurno) => {
      return bodyTurno.turno === turnoFiltered;
    });
    let returnTitle = "";
    if (typeof turnoFiltered == "string") {
      returnTitle = turnoList.filter((e) => e.label == turnoFiltered)[0].label;
    } else {
      returnTitle = turnoList.filter((e) => e.value == turnoFiltered)[0].label;
    }
    return {
      title: returnTitle,
      values: [...filteredData],
    };
  });
}

const { form } = toRefs(data);

return (_ctx: any,_cache: any) => {
  const _component_InputCustom = _resolveComponent("InputCustom")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(setDadosTabela, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(_unref(nomeEnsino)), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", _hoisted_6, [
              _createElementVNode("tr", null, [
                _cache[0] || (_cache[0] = _createElementVNode("th", { class: "ps-5" }, "Turno", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(header.value, ({ turno }, index) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: turno + index,
                    class: "ps-5"
                  }, _toDisplayString(turno), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(body.value, ({ title, values }, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: title + index
                }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(title), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(header.value, ({ turno }, index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: index,
                      class: "ps-5"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values, (value) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: value.id
                        }, [
                          (turno == value.fase)
                            ? _withDirectives((_openBlock(), _createBlock(_component_InputCustom, {
                                key: 0,
                                modelValue: _unref(form).input[`id_${value.id}`],
                                "onUpdate:modelValue": ($event: any) => ((_unref(form).input[`id_${value.id}`]) = $event),
                                class: "p-1 widthInput"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])), [
                                [_directive_mask, _ctx.mask]
                              ])
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-footer d-flex justify-content-end" }, [
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary"
        }, "Salvar")
      ], -1))
    ], 32)
  ]))
}
}

})